import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.loading)?_c(VIcon,{attrs:{"color":"primary"}},[_vm._v("mdi-all-inclusive")]):_vm._e(),(_vm.active && !_vm.loading)?_c(VIcon,{attrs:{"color":"green darken-1"},on:{"click":function($event){return _vm.activate()}}},[_vm._v("mdi-toggle-switch")]):_vm._e(),(!_vm.active && !_vm.loading)?_c(VIcon,{on:{"click":function($event){return _vm.deactivate()}}},[_vm._v("mdi-toggle-switch-off")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }